module.exports = __webpack_public_path__ + "img/bg4-mobile.24749c80.jpg";